export default __webpack_public_path__ + "static/media/mulan.68eecc2c.png";